<template>
    <div>
        <div class="container NotFoundPage d-flex flex-column align-items-center justify-content-center">

            <div v-if="isLogo" class="mb-5 text-center">
                <router-link to="/">
                    <img src="@/assets/logo.png" style="width: 180px" alt="" />
                </router-link>
            </div>

            <div class="text-center">
                <svg width="500" height="270" viewBox="0 0 694 432" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_0_48)">
                        <path
                            d="M62.7827 347.443L51.43 305.074L104.641 135.29L142.29 125.202L157.701 182.718L135.858 188.571L104.846 288.409L105.316 290.165L238.68 254.43L250.15 297.238L62.7827 347.443ZM181.339 355.675L167.869 305.403L163.996 286.559L122.203 130.584L173.024 116.967L233.258 341.764L181.339 355.675Z"
                            fill="#82C122" />
                        <path
                            d="M347.472 305.682C408.381 305.795 445.767 260.795 445.881 183.977C445.994 107.614 408.381 64.0909 347.472 64.0909C286.562 64.0909 249.29 107.5 249.176 183.977C248.949 260.568 286.562 305.682 347.472 305.682ZM347.472 259.659C323.267 259.659 306.79 235.341 307.017 183.977C307.131 133.636 323.381 109.773 347.472 109.773C371.676 109.773 387.926 133.636 388.04 183.977C388.153 235.341 371.79 259.659 347.472 259.659Z"
                            fill="#223051" />
                        <path
                            d="M345.472 286.682C325.169 286.682 307.669 281.871 292.972 272.25C278.275 262.553 266.949 248.652 258.994 230.545C251.04 212.364 247.1 190.508 247.176 164.977C247.252 139.447 251.229 117.78 259.108 99.9773C267.063 82.0985 278.35 68.5 292.972 59.1818C307.669 49.7879 325.169 45.0909 345.472 45.0909C365.775 45.0909 383.275 49.7879 397.972 59.1818C412.744 68.5 424.108 82.0985 432.062 99.9773C440.017 117.856 443.956 139.523 443.881 164.977C443.881 190.583 439.903 212.477 431.949 230.659C423.994 248.841 412.669 262.742 397.972 272.364C383.35 281.909 365.85 286.682 345.472 286.682ZM345.472 240.659C357.593 240.659 367.403 234.485 374.903 222.136C382.403 209.712 386.116 190.659 386.04 164.977C386.04 148.159 384.335 134.295 380.926 123.386C377.517 112.402 372.782 104.22 366.722 98.8409C360.661 93.4621 353.578 90.7727 345.472 90.7727C333.426 90.7727 323.691 96.8712 316.267 109.068C308.843 121.189 305.093 139.826 305.017 164.977C304.941 182.023 306.57 196.152 309.903 207.364C313.313 218.576 318.085 226.947 324.222 232.477C330.358 237.932 337.441 240.659 345.472 240.659Z"
                            fill="#82C122" />
                        <path
                            d="M446.736 298.012L458.089 255.643L589.063 135.21L626.712 145.298L611.301 202.815L589.458 196.962L512.681 267.918L512.211 269.674L645.575 305.409L634.104 348.217L446.736 298.012ZM545.294 364.419L558.764 314.147L564.832 295.891L606.625 139.916L657.446 153.534L597.212 378.331L545.294 364.419Z"
                            fill="#82C122" />
                    </g>
                    <defs>
                        <clipPath id="clip0_0_48">
                            <rect width="694" height="432" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                <h2 class="error-title text-uppercase">SAHIFA TOPILMADI</h2>
            </div>

            <div class="row align-items-center justify-content-center mb-4">
                <div class="col-auto">
                    <p class="description-text mb-0 text-center">
                        Siz izlayotgan sahifa mavjud emas.
                    </p>
                </div>
            </div>

            <div class="mt-3">
                <a href="/" class="btn btn-green returnBtn">
                    Bosh sahifaga qaytish
                </a>
            </div>

        </div>
    </div>
</template>

<script setup>
defineProps({
    isLogo: {
        type: Boolean,
        default: true,
    }
})
</script>

<style lang="scss" scoped>
.NotFoundPage {
    min-height: calc(100dvh - 210px);
}

.returnBtn {
    color: white !important;
}
</style>